// Shared MapLibre style for every admin map (RouteBuilderModal, AdminEventCompanion's
// GPX preview, AdminIncidents).
//
// This MUST be the exact same basemap StapKompas shows participants
// (companion-app/src/lib/mapStyle.js). The admin draws a route by eye, against the
// paths the map renders — so if the two apps render different paths, a route that
// looks correct while drawing lands visibly beside the path in StapKompas. That was a
// real, reported production problem: the admin used MapTiler's nl-cartiqo-topo style,
// which does not render every park footpath at drawing zoom, while StapKompas uses
// OpenFreeMap Liberty, which does — so the admin was clicking along a park edge with
// no visible path to follow, and the participant then saw the route miss the footpath
// that was plainly drawn on their own map. The route geometry was identical in both;
// only the basemap differed.
//
// OpenFreeMap Liberty is a MapLibre-native vector style, needs no API key or account,
// renders street-level detail down to walking-navigation zoom, and carries its own
// required attribution.
//
// REACT_APP_MAPLIBRE_STYLE_URL is deliberately NOT read any more. Keeping it would
// re-open the exact mismatch above the moment it is set on only one of the two
// Cloudflare Pages projects — which is what happened. It can be removed from the
// admin project's environment variables; leaving it set changes nothing.
export const OPENFREEMAP_STYLE_URL = "https://tiles.openfreemap.org/styles/liberty";

export const MAP_STYLE_URL = OPENFREEMAP_STYLE_URL;

// There is no deployment-time map-style configuration left that can be invalid, so
// there is nothing to validate at module load. Kept as an export because all three
// admin map call sites branch on it before constructing a map.
export const MAP_STYLE_CONFIG_ERROR = null;

// Only for a genuine runtime failure (provider outage, network, WebGL context loss).
export const MAP_STYLE_LOAD_ERROR_MESSAGE =
  "De kaartondergrond kon niet worden geladen. Controleer je internetverbinding en probeer het opnieuw.";
